import {
  Box,
  Card,
  Flex,
  GlobeIcon,
  Image,
  MoreIcon,
  Typography,
} from '@iheartjane/reefer';
import { processSeoVariables, usStatesHash } from '@iheartjane/utils';

import styles from './PreviewSeo.module.css';

/** Mirrors Google's breadcrumb display, e.g. "example.com › shop › flower" */
const formatDisplayUrl = (url: string) => {
  const normalized = url.replace(/ /g, '-').toLowerCase();
  try {
    const { hostname, pathname } = new URL(normalized);
    return [hostname, ...pathname.split('/').filter(Boolean)].join(' › ');
  } catch {
    return normalized;
  }
};

export const PreviewSeo = ({
  description,
  faviconUrl,
  menuUrl,
  title,
  variables,
}: {
  description?: string;
  faviconUrl?: string | null;
  menuUrl?: string;
  title?: string;
  variables: Record<string, unknown>;
}) => {
  const seoVariables = {
    ...variables,
    storeStateAbbr: usStatesHash[variables['storeStateAbbr'] as string],
  };

  return (
    <Card style={{ '--card-border-radius': '16px' }}>
      <Card.Content p={24} background="grays-ultralight">
        <Flex flexDirection="column">
          <Typography color="grays-mid" variant="body-semibold">
            Preview
          </Typography>
          <Flex
            flexDirection="column"
            background="grays-white"
            gap={12}
            p={24}
            mt={8}
            border="grays-light"
            borderRadius="xs"
          >
            {menuUrl && (
              <Flex alignItems="center" gap={12}>
                <Box
                  background="grays-ultralight"
                  className={styles['favicon']}
                >
                  {faviconUrl ? (
                    <Image
                      src={faviconUrl}
                      altText="Favicon"
                      height="18px"
                      width="18px"
                      objectFit="contain"
                    />
                  ) : (
                    <GlobeIcon size="sm" color="grays-mid" />
                  )}
                </Box>
                <Flex flexDirection="column">
                  <Typography variant="small-body-regular" color="grays-black">
                    {variables['storeName'] as string}
                  </Typography>
                  <Flex alignItems="center" gap={4}>
                    <Typography variant="small-body-regular" color="grays-mid">
                      {formatDisplayUrl(menuUrl ?? '')}
                    </Typography>
                    <MoreIcon size="sm" rotate="right" color="grays-mid" />
                  </Flex>
                </Flex>
              </Flex>
            )}

            <Typography
              variant={menuUrl ? 'h3-regular' : 'h2-semibold'}
              color={menuUrl ? 'purple-dark' : 'grays-black'}
            >
              {processSeoVariables(title, seoVariables)}
            </Typography>

            <Typography variant="small-body-regular" color="grays-dark">
              {processSeoVariables(description, seoVariables)}
            </Typography>
          </Flex>
        </Flex>
      </Card.Content>
    </Card>
  );
};
